import { memo } from 'react';
import { capitalize } from 'lodash';
import { Divider as MuiDivider, type DividerProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'PaddedDivider' })((theme) => ({
  divider: {
    borderColor: theme.palette.grey[300],
  },
  marginXsmall: {
    margin: theme.spacing(1, 0),
  },
  marginSmall: {
    margin: theme.spacing(2, 0),
  },
  marginMedium: {
    margin: theme.spacing(3, 0),
  },
  marginLarge: {
    margin: theme.spacing(4, 0),
  },
  paddingStack: {
    paddingTop: theme.spacing(2),
    marginBottom: `${theme.spacing(2)} !important`,
  },
  extended: {
    marginLeft: theme.spacing(2 * -1),
    marginRight: theme.spacing(2 * -1),
  },
}));

interface PaddedDividerProps extends DividerProps {
  readonly padding?: 'stack' | 'none';
  readonly margin?: 'xsmall' | 'small' | 'medium' | 'large';
  readonly className?: string;
  readonly extended?: boolean;
}

export const PaddedDivider = memo(({
  margin = 'small', className = '', padding = 'none', extended = false,
  ...restProps
}: PaddedDividerProps) => {
  const { classes, cx } = useStyles();

  return (
    <MuiDivider
      className={cx(
        classes.divider,
        classes[`margin${capitalize(margin)}`],
        padding === 'stack' && classes.paddingStack,
        extended && classes.extended,
        className,
      )}
      {...restProps}
    />
  );
});
